import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/calendar-icon.svg'
import _imports_1 from '@/assets/gray-user.svg'
import _imports_2 from '@/assets/pencil-gray.svg'


const _hoisted_1 = { class: "flex flex-col gap-3 relative p-3" }
const _hoisted_2 = {
  key: 0,
  class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "flex flex-col gap-3"
}
const _hoisted_5 = { class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow flex flex-col gap-2" }
const _hoisted_6 = { class: "w-full flex items-center justify-between" }
const _hoisted_7 = { class: "flex items-center gap-3" }
const _hoisted_8 = { class: "flex items-center gap-1" }
const _hoisted_9 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_10 = { class: "flex items-center gap-1" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = {
  key: 0,
  class: "text-base font-normal"
}
const _hoisted_15 = {
  key: 1,
  class: "text-base font-normal"
}
const _hoisted_16 = { class: "p-3 rounded-primary-radius bg-[#e5ecf6] mt-2" }
const _hoisted_17 = { class: "text-base font-normal" }
const _hoisted_18 = {
  key: 3,
  class: "flex gap-1"
}
const _hoisted_19 = { class: "p-3 w-1/3 bg-white rounded-primary-radius shadow-primary-box-shadow" }
const _hoisted_20 = { class: "w-full flex items-center justify-between" }
const _hoisted_21 = { class: "flex items-center gap-3" }
const _hoisted_22 = { class: "flex items-center gap-1" }
const _hoisted_23 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_24 = { class: "flex items-center gap-1" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "mt-4 flex gap-2" }
const _hoisted_28 = { class: "text-base font-normal grow" }
const _hoisted_29 = { class: "px-3 py-[1px] rounded-primary-radius bg-[#e5ecf6] mt-2 h-fit w-fit" }
const _hoisted_30 = { class: "text-base font-normal h-fit w-fit" }
const _hoisted_31 = {
  key: 4,
  class: "flex flex-col gap-3"
}
const _hoisted_32 = { class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow flex flex-col gap-2" }
const _hoisted_33 = { class: "w-full flex items-center justify-between" }
const _hoisted_34 = { class: "flex items-center gap-3" }
const _hoisted_35 = { class: "flex items-center gap-1" }
const _hoisted_36 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_37 = { class: "flex items-center gap-1" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "mt-4" }
const _hoisted_41 = { class: "text-base font-normal text-" }
const _hoisted_42 = { class: "p-3 rounded-primary-radius bg-[#e5ecf6] mt-2" }
const _hoisted_43 = { class: "text-base font-normal text-" }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "flex flex-col gap-3 relative" }
const _hoisted_46 = {
  key: 0,
  class: "text-lg leading-[32px] tracking-[0.01rem] text-primary-text-color font-semibold"
}
const _hoisted_47 = {
  key: 0,
  class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow"
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 2,
  class: "flex flex-col gap-3"
}
const _hoisted_50 = { class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow flex flex-col gap-2" }
const _hoisted_51 = { class: "w-full flex items-center justify-between" }
const _hoisted_52 = { class: "flex items-center gap-3" }
const _hoisted_53 = { class: "flex items-center gap-1" }
const _hoisted_54 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_55 = { class: "flex items-center gap-1" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "mt-4" }
const _hoisted_59 = {
  key: 0,
  class: "text-base font-normal"
}
const _hoisted_60 = {
  key: 1,
  class: "text-base font-normal text-"
}
const _hoisted_61 = { class: "p-3 rounded-primary-radius bg-[#e5ecf6] mt-2" }
const _hoisted_62 = { class: "text-base font-normal text-" }
const _hoisted_63 = {
  key: 3,
  class: "flex gap-1"
}
const _hoisted_64 = { class: "p-3 w-1/3 bg-white rounded-primary-radius shadow-primary-box-shadow" }
const _hoisted_65 = { class: "w-full flex items-center justify-between" }
const _hoisted_66 = { class: "flex items-center gap-3" }
const _hoisted_67 = { class: "flex items-center gap-1" }
const _hoisted_68 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_69 = { class: "flex items-center gap-1" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "mt-4 flex gap-2" }
const _hoisted_73 = {
  key: 0,
  class: "text-base font-normal"
}
const _hoisted_74 = {
  key: 1,
  class: "text-base font-normal grow"
}
const _hoisted_75 = { class: "px-3 py-[1px] rounded-primary-radius bg-[#e5ecf6] mt-2 h-fit w-fit" }
const _hoisted_76 = { class: "text-base font-normal h-fit w-fit" }
const _hoisted_77 = {
  key: 4,
  class: "flex flex-col gap-3"
}
const _hoisted_78 = { class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow flex flex-col gap-2" }
const _hoisted_79 = { class: "w-full flex items-center justify-between" }
const _hoisted_80 = { class: "flex items-center gap-3" }
const _hoisted_81 = { class: "flex items-center gap-1" }
const _hoisted_82 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_83 = { class: "flex items-center gap-1" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "mt-4" }
const _hoisted_87 = {
  key: 0,
  class: "text-base font-normal"
}
const _hoisted_88 = {
  key: 1,
  class: "text-base font-normal text-"
}
const _hoisted_89 = { class: "p-3 rounded-primary-radius bg-[#e5ecf6] mt-2" }
const _hoisted_90 = { class: "text-base font-normal text-" }

import { ref } from "vue";
import InputModal from "../InputModal.vue";
import SlideImagesBlock from "./SlideImagesBlock.vue";
import CheckListBlock from "./CheckListBlock.vue";
import AddImageModal from "../AddImageModal.vue";
import CustomAccordion from "./CustomAccordion.vue";

type Props = {
  input: any;
  project: string | string[];
  phase: number;
  phaseDetails: any;
  step: any;
  showDetails?: boolean;
  isAccordion?: boolean;
  phaseStatus?: string;
};
type Emits = {
  (event: "refresh"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'RepeatableInput',
  props: {
    input: {},
    project: {},
    phase: {},
    phaseDetails: {},
    step: {},
    showDetails: { type: Boolean },
    isAccordion: { type: Boolean },
    phaseStatus: {}
  },
  emits: ["refresh"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const isInputModalOpen = ref(false);
const isAddImageModalOpen = ref(false);
const selectedInput = ref<any>(null);
const selectedStep = ref<any>(null);
const selectedInputGroupIndex = ref<any>(null);
const selectedInputIndex = ref<any>(null);

const toggleModalHandler: any = (
  input: any,
  step: any,
  inputIndex?: number,
  groupIndex?: number
) => {
  selectedInput.value = input;
  selectedStep.value = step;
  isInputModalOpen.value = !isInputModalOpen.value;
  selectedInputGroupIndex.value = groupIndex;
  selectedInputIndex.value = inputIndex;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isInputModalOpen.value && selectedInput.value)
      ? (_openBlock(), _createBlock(InputModal, {
          key: 0,
          input: selectedInput.value,
          step: selectedStep.value,
          "is-open": isInputModalOpen.value,
          project: __props.project,
          phase: __props.phase,
          termins: __props.phaseDetails.termins,
          "input-index": selectedInputIndex.value,
          "group-index": selectedInputGroupIndex.value,
          onRefresh: _cache[0] || (_cache[0] = () => emits('refresh')),
          onToggleModal: _cache[1] || (_cache[1] = 
      () => {
        isInputModalOpen.value = false;
        selectedInput.value = null;
        selectedStep.value = null;
      }
    )
        }, null, 8, ["input", "step", "is-open", "project", "phase", "termins", "input-index", "group-index"]))
      : _createCommentVNode("", true),
    (isAddImageModalOpen.value && selectedInput.value)
      ? (_openBlock(), _createBlock(AddImageModal, {
          key: 1,
          steps: __props.phaseDetails.steps,
          termins: __props.phaseDetails.termins,
          "is-open": isAddImageModalOpen.value,
          project: __props.project,
          input: selectedInput.value,
          step: selectedStep.value,
          "header-title": selectedInput.value ? selectedInput.value.name : '',
          phase: __props.phase,
          "group-index": selectedInputGroupIndex.value,
          "input-index": selectedInputIndex.value,
          onToggleModal: _cache[2] || (_cache[2] = ($event: any) => (isAddImageModalOpen.value = false)),
          onRefresh: _cache[3] || (_cache[3] = () => emits('refresh'))
        }, null, 8, ["steps", "termins", "is-open", "project", "input", "step", "header-title", "phase", "group-index", "input-index"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: _normalizeClass(`${
        __props.input.isConditionallyRepetable ? 'bg-transparent' : 'bg-[#E5E4E2]'
      }  rounded-primary-radius`)
      }, [
        (__props.isAccordion && !__props.input.isConditionallyRepetable)
          ? (_openBlock(), _createBlock(CustomAccordion, {
              key: 0,
              "step-name": `${!__props.input.isConditionallyRepetable ? __props.input.name : ''}`,
              "sticky-height": `${
          __props.showDetails ? 'top-[383px]' : 'top-[180px]'
        } sticky z-[16]`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.input.value.filter((item)=> item.value), (repeatableInput) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: repeatableInput.index
                    }, [
                      (__props.input.subtype === 'checkbox' && repeatableInput.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(CheckListBlock, {
                              checklist: [
                  {
                    id: repeatableInput.index,
                    name: `${__props.input.repeatableInputNoun} ${
                      repeatableInput.index + 1
                    }`,
                    value: repeatableInput.value,
                  },
                ]
                            }, null, 8, ["checklist"])
                          ]))
                        : _createCommentVNode("", true),
                      (
                __props.input.subtype === 'image' &&
                repeatableInput.value &&
                repeatableInput.value.length > 0
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(), _createElementBlock("div", {
                              key: repeatableInput.index,
                              class: "flex flex-col gap-1"
                            }, [
                              _createVNode(SlideImagesBlock, {
                                "is-group": true,
                                "show-details": __props.showDetails,
                                "header-class": `${
                    __props.showDetails ? 'top-[387px]' : 'top-[187px]'
                  } sticky z-[15]`,
                                onAddImageModalOpen: 
                    () => {
                      selectedInput.value = __props.input;
                      selectedStep.value = __props.step;
                      isAddImageModalOpen.value = true;
                      selectedInputGroupIndex.value = __props.input.repeatableGroupIndex;
                      selectedInputIndex.value = repeatableInput.index;
                    }
                  ,
                                input: {
                    id: __props.input.id,
                    name: `${__props.input.repeatableInputNoun} ${
                      repeatableInput.index + 1
                    }`,
                    value: repeatableInput.value,
                  },
                                step: __props.step,
                                steps: __props.phaseDetails.steps,
                                refresh: () => _ctx.$emit('refresh')
                              }, null, 8, ["show-details", "header-class", "onAddImageModalOpen", "input", "step", "steps", "refresh"])
                            ]))
                          ]))
                        : _createCommentVNode("", true),
                      (__props.input.subtype === 'text')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("div", _hoisted_8, [
                                    _cache[4] || (_cache[4] = _createElementVNode("img", {
                                      class: "w-3 h-3 cursor-pointer",
                                      src: _imports_0,
                                      alt: "Calendar"
                                    }, null, -1)),
                                    _createElementVNode("p", _hoisted_9, _toDisplayString(repeatableInput.createdAt
                            ? new Date(
                                repeatableInput.createdAt
                              ).toLocaleDateString("de")
                            : ""), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_10, [
                                    _cache[5] || (_cache[5] = _createElementVNode("img", {
                                      class: "w-3 h-3",
                                      src: _imports_1,
                                      alt: "User"
                                    }, null, -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repeatableInput.workers, (worker, index) => {
                                      return (_openBlock(), _createElementBlock("p", {
                                        key: index,
                                        class: "text-sm text-[#898790] foont-medium"
                                      }, [
                                        _createTextVNode(_toDisplayString(worker.fullname), 1),
                                        (index < repeatableInput.workers.length - 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, ","))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("img", {
                                  onClick: ($event: any) => (
                      toggleModalHandler(
                        __props.input,
                        __props.step,
                        repeatableInput.index,
                        __props.input.repeatableGroupIndex
                      )
                    ),
                                  class: "w-4 h-4 cursor-pointer",
                                  src: _imports_2,
                                  alt: "Pencil"
                                }, null, 8, _hoisted_12)
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                (__props.input.isConditionallyRepetable)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(__props.input.name) + " " + _toDisplayString(repeatableInput.index + 1), 1))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(__props.input.repeatableInputNoun) + " " + _toDisplayString(repeatableInput.index + 1), 1)),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("p", _hoisted_17, _toDisplayString(repeatableInput.value), 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (__props.input.subtype === 'number')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _cache[6] || (_cache[6] = _createElementVNode("img", {
                                      class: "w-3 h-3 cursor-pointer",
                                      src: _imports_0,
                                      alt: "Calendar"
                                    }, null, -1)),
                                    _createElementVNode("p", _hoisted_23, _toDisplayString(repeatableInput.createdAt
                            ? new Date(
                                repeatableInput.createdAt
                              ).toLocaleDateString("de")
                            : ""), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_24, [
                                    _cache[7] || (_cache[7] = _createElementVNode("img", {
                                      class: "w-3 h-3",
                                      src: _imports_1,
                                      alt: "User"
                                    }, null, -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repeatableInput.workers, (worker, index) => {
                                      return (_openBlock(), _createElementBlock("p", {
                                        key: index,
                                        class: "text-sm text-[#898790] font-medium"
                                      }, [
                                        _createTextVNode(_toDisplayString(worker.fullname), 1),
                                        (index < repeatableInput.workers.length - 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, ","))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("img", {
                                  onClick: ($event: any) => (
                      toggleModalHandler(
                        __props.input,
                        __props.step,
                        repeatableInput.index,
                        __props.input.repeatableGroupIndex
                      )
                    ),
                                  class: "w-4 h-4 cursor-pointer",
                                  src: _imports_2,
                                  alt: "Pencil"
                                }, null, 8, _hoisted_26)
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("p", _hoisted_28, _toDisplayString(__props.input.repeatableInputNoun) + " " + _toDisplayString(repeatableInput.index + 1), 1),
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("p", _hoisted_30, _toDisplayString(repeatableInput.value), 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                __props.input.subtype === 'select' || __props.input.subtype === 'static_select'
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", _hoisted_35, [
                                    _cache[8] || (_cache[8] = _createElementVNode("img", {
                                      class: "w-3 h-3 cursor-pointer",
                                      src: _imports_0,
                                      alt: "Calendar"
                                    }, null, -1)),
                                    _createElementVNode("p", _hoisted_36, _toDisplayString(repeatableInput.createdAt
                            ? new Date(
                                repeatableInput.createdAt
                              ).toLocaleDateString("de")
                            : ""), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_37, [
                                    _cache[9] || (_cache[9] = _createElementVNode("img", {
                                      class: "w-3 h-3",
                                      src: _imports_1,
                                      alt: "User"
                                    }, null, -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repeatableInput.workers, (worker, index) => {
                                      return (_openBlock(), _createElementBlock("p", {
                                        key: index,
                                        class: "text-sm text-[#898790] font-medium"
                                      }, [
                                        _createTextVNode(_toDisplayString(worker.fullname), 1),
                                        (index < repeatableInput.workers.length - 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, ","))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("img", {
                                  onClick: ($event: any) => (
                      toggleModalHandler(
                        __props.input,
                        __props.step,
                        repeatableInput.index,
                        __props.input.repeatableGroupIndex
                      )
                    ),
                                  class: "w-4 h-4 cursor-pointer",
                                  src: _imports_2,
                                  alt: "Pencil"
                                }, null, 8, _hoisted_39)
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("p", _hoisted_41, _toDisplayString(__props.input.repeatableInputNoun) + " " + _toDisplayString(repeatableInput.index + 1), 1),
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("p", _hoisted_43, _toDisplayString(repeatableInput.value
                          ? __props.input.options.find(
                              (option) =>
                                Number(option.id) ===
                                Number(repeatableInput.value)
                            )?.option
                          : ""), 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["step-name", "sticky-height"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                (!__props.input.isConditionallyRepetable)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_46, _toDisplayString(__props.input.name), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.input.value.filter((item)=> item.value  && item.value.length > 0), (repeatableInput) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: repeatableInput.index,
                    class: "bg-[#E5E4E2] rounded-primary-radius p-3"
                  }, [
                    (__props.input.subtype === 'checkbox' && repeatableInput.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createVNode(CheckListBlock, {
                            checklist: [
                  {
                    id: repeatableInput.index,
                    name: `${__props.input.repeatableInputNoun} ${
                      repeatableInput.index + 1
                    }`,
                    value: repeatableInput.value,
                  },
                ]
                          }, null, 8, ["checklist"])
                        ]))
                      : _createCommentVNode("", true),
                    (__props.input.subtype === 'image')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          (_openBlock(), _createElementBlock("div", {
                            key: repeatableInput.index,
                            class: "flex flex-col gap-1"
                          }, [
                            _createVNode(SlideImagesBlock, {
                              "is-group": true,
                              "show-details": __props.showDetails,
                              "header-class": `${
                    __props.showDetails ? 'top-[387px]' : 'top-[187px]'
                  } sticky z-[11]`,
                              onAddImageModalOpen: 
                    () => {
                      selectedInput.value = __props.input;
                      selectedStep.value = __props.step;
                      isAddImageModalOpen.value = true;
                      selectedInputGroupIndex.value = __props.input.repeatableGroupIndex;
                      selectedInputIndex.value = repeatableInput.index;
                    }
                  ,
                              input: {
                    id: __props.input.id,
                    name: `${
                      __props.input.isConditionallyRepetable
                        ? __props.input.name
                        : __props.input.repeatableInputNoun
                    } ${repeatableInput.index + 1}`,
                    value: repeatableInput.value,
                  },
                              step: __props.step,
                              steps: __props.phaseDetails.steps,
                              refresh: () => _ctx.$emit('refresh')
                            }, null, 8, ["show-details", "header-class", "onAddImageModalOpen", "input", "step", "steps", "refresh"])
                          ]))
                        ]))
                      : _createCommentVNode("", true),
                    (__props.input.subtype === 'text')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("div", _hoisted_53, [
                                  _cache[10] || (_cache[10] = _createElementVNode("img", {
                                    class: "w-3 h-3 cursor-pointer",
                                    src: _imports_0,
                                    alt: "Calendar"
                                  }, null, -1)),
                                  _createElementVNode("p", _hoisted_54, _toDisplayString(repeatableInput.createdAt
                            ? new Date(
                                repeatableInput.createdAt
                              ).toLocaleDateString("de")
                            : ""), 1)
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                  _cache[11] || (_cache[11] = _createElementVNode("img", {
                                    class: "w-3 h-3",
                                    src: _imports_1,
                                    alt: "User"
                                  }, null, -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repeatableInput.workers, (worker, index) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: index,
                                      class: "text-sm text-[#898790] foont-medium"
                                    }, [
                                      _createTextVNode(_toDisplayString(worker?.fullname), 1),
                                      (index < repeatableInput.workers.length - 1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_56, ","))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("img", {
                                onClick: ($event: any) => (
                      toggleModalHandler(
                        __props.input,
                        __props.step,
                        repeatableInput.index,
                        __props.input.repeatableGroupIndex
                      )
                    ),
                                class: "w-4 h-4 cursor-pointer",
                                src: _imports_2,
                                alt: "Pencil"
                              }, null, 8, _hoisted_57)
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              (__props.input.isConditionallyRepetable)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(__props.input.name) + " " + _toDisplayString(repeatableInput.index + 1), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(__props.input.name), 1)),
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("p", _hoisted_62, _toDisplayString(repeatableInput.value), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (__props.input.subtype === 'number')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, [
                                _createElementVNode("div", _hoisted_67, [
                                  _cache[12] || (_cache[12] = _createElementVNode("img", {
                                    class: "w-3 h-3 cursor-pointer",
                                    src: _imports_0,
                                    alt: "Calendar"
                                  }, null, -1)),
                                  _createElementVNode("p", _hoisted_68, _toDisplayString(repeatableInput.createdAt
                            ? new Date(
                                repeatableInput.createdAt
                              ).toLocaleDateString("de")
                            : ""), 1)
                                ]),
                                _createElementVNode("div", _hoisted_69, [
                                  _cache[13] || (_cache[13] = _createElementVNode("img", {
                                    class: "w-3 h-3",
                                    src: _imports_1,
                                    alt: "User"
                                  }, null, -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repeatableInput.workers, (worker, index) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: index,
                                      class: "text-sm text-[#898790] font-medium"
                                    }, [
                                      _createTextVNode(_toDisplayString(worker.fullname), 1),
                                      (index < repeatableInput.workers.length - 1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_70, ","))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("img", {
                                onClick: ($event: any) => (
                      toggleModalHandler(
                        __props.input,
                        __props.step,
                        repeatableInput.index,
                        __props.input.repeatableGroupIndex
                      )
                    ),
                                class: "w-4 h-4 cursor-pointer",
                                src: _imports_2,
                                alt: "Pencil"
                              }, null, 8, _hoisted_71)
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              (__props.input.isConditionallyRepetable)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_73, _toDisplayString(__props.input.name) + " " + _toDisplayString(repeatableInput.index + 1), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString(__props.input.name), 1)),
                              _createElementVNode("div", _hoisted_75, [
                                _createElementVNode("p", _hoisted_76, _toDisplayString(repeatableInput.value), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (
                __props.input.subtype === 'select' || __props.input.subtype === 'static_select'
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, [
                              _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("div", _hoisted_81, [
                                  _cache[14] || (_cache[14] = _createElementVNode("img", {
                                    class: "w-3 h-3 cursor-pointer",
                                    src: _imports_0,
                                    alt: "Calendar"
                                  }, null, -1)),
                                  _createElementVNode("p", _hoisted_82, _toDisplayString(repeatableInput.createdAt
                            ? new Date(
                                repeatableInput.createdAt
                              ).toLocaleDateString("de")
                            : ""), 1)
                                ]),
                                _createElementVNode("div", _hoisted_83, [
                                  _cache[15] || (_cache[15] = _createElementVNode("img", {
                                    class: "w-3 h-3",
                                    src: _imports_1,
                                    alt: "User"
                                  }, null, -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repeatableInput.workers, (worker, index) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: index,
                                      class: "text-sm text-[#898790] font-medium"
                                    }, [
                                      _createTextVNode(_toDisplayString(worker.fullname), 1),
                                      (index < repeatableInput.workers.length - 1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_84, ","))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("img", {
                                onClick: ($event: any) => (
                      toggleModalHandler(
                        __props.input,
                        __props.step,
                        repeatableInput.index,
                        __props.input.repeatableGroupIndex
                      )
                    ),
                                class: "w-4 h-4 cursor-pointer",
                                src: _imports_2,
                                alt: "Pencil"
                              }, null, 8, _hoisted_85)
                            ]),
                            _createElementVNode("div", _hoisted_86, [
                              (__props.input.isConditionallyRepetable)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_87, _toDisplayString(__props.input.name) + " " + _toDisplayString(repeatableInput.index + 1), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_88, _toDisplayString(__props.input.name), 1)),
                              _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("p", _hoisted_90, _toDisplayString(repeatableInput.value), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
      ], 2)
    ])
  ], 64))
}
}

})